import React, { Suspense, lazy } from "react"
import { Switch, Route, useLocation } from "react-router-dom"
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles"
import { Helmet } from "react-helmet"
import CssBaseline from "@mui/material/CssBaseline"

import { page } from "../utils/analytics"
import "../index.css"
import ErrorBoundary from "../components/ErrorBoundary"
import Loading from "../components/template-parts/Loading"
import theme from "../theme"

const AsyncAppRouter = lazy(() => import("./AppRouter"))

const ScrollToTop = () => {
  window.scrollTo(0, 0)
  return null
}

const App = () => {
  const [prevPath, setPrevPath] = React.useState("")
  const location = useLocation()

  React.useEffect(() => {
    const nextPage = `${location.pathname}${location.search}`
    if (prevPath !== nextPage) {
      page(nextPage)
      setPrevPath(nextPage)
    }
  }, [location.pathname, location.search, prevPath])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <>
            <Helmet titleTemplate="%s | Driving Lessons & Drivers Ed by Coastline">
              <title>The Modern Driving School</title>
              <meta
                name="description"
                content="Coastline Academy is the modern driving school. Book a driving lesson in your city today."
              />
            </Helmet>

            <Suspense fallback={<Loading />}>
              <Route>
                <ScrollToTop />
              </Route>
              <Switch>
                <Route path="*">
                  <AsyncAppRouter />
                </Route>
              </Switch>
            </Suspense>
            {process.env.REACT_APP_ENV !== "production" && (
              <div className="sandbox-notification">
                Using Sandbox Environment
              </div>
            )}
          </>
        </ErrorBoundary>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
